import * as Yup from 'yup';
import i18next from 'i18next';

export const validation = Yup.object().shape({
  username: Yup.string()
    .required(() => i18next.t('resetPass_required'))
});
